export const PromoCodeErrorExtensions = {
  PROMO_CODE_INVALID: 'PROMO_CODE_INVALID',
  PROMO_CODE_NOT_FOUND: 'PROMO_CODE_NOT_FOUND',
  PROMO_CODE_EXPIRED: 'PROMO_CODE_EXPIRED',
  PROMO_CODE_NOT_ELIGIBLE: 'PROMO_CODE_NOT_ELIGIBLE',
  PROMO_CODE_ALREADY_REDEEMED: 'PROMO_CODE_ALREADY_REDEEMED',
  PROMO_CODE_INVALID_BILLING_PERIOD: 'PROMO_CODE_INVALID_BILLING_PERIOD',
} as const;
